import React, { useState, useEffect, createContext } from 'react'
import Label from '../Label/Label'
import useInput from '../useInput'
import useValidation from '../useValidation'
import Icon from '../../Icon/Icon'
import Button from '../../Button/Button'
import { Visible } from '../../../index'

const InputWrapper = (props: any) => {
    const {
        inputType,
        className = '',
        label,
        noLabel,
        data,
        isValid,
        isValidating,
        isFocused,
        isDisabled,
        isDisplay,
        isDirty,
        name,
        onMount,
        onValidityChange,
        isRequired,
        col,
        validation,
        validationMessage,
        hideValidationContainer = false,
        hideValidationState = false,
        button,
        value,
        textField,
        valueField,
        displayValue,
        labelStyle = 'default',
        description,
        showValidationOnDirty = false,
        placeholder,
        icon,
        onLabelClick = () => {},
    } = props
    useEffect(() => {}, [])

    const constructLabel = () => {
        if (noLabel) {
            return null
        }
        let _label = label
        if (typeof label === 'object') {
            _label = label.text
        } else if (!label) {
            _label = name
                .split('.')
                .pop()
                .toString()
                .split(/(?=[A-Z])/)
                .join(' ')
                .replace(/\b\w/g, function (l) {
                    return l.toUpperCase()
                })
        }

        return _label
    }

    const constructedLabel = constructLabel()

    const isInvalid = !isValid && !isValidating && !isFocused
    const showValidationMessage =
        hideValidationState === true ? false : showValidationOnDirty ? isDirty && isInvalid : isInvalid

    const convertObjectToStringValue = (v) => {
        if (textField && valueField && data.length > 0) {
            const dataItem = data.find((d) => d[valueField] === v)

            if (dataItem) {
                return dataItem[textField]
            }

            throw Error('Dataitem for value ' + v + ' not found')
            return v[textField]
        }
        return v
    }

    const renderDisplayValue = () => {
        if (displayValue) {
            return displayValue
        }

        if (value === null || value === undefined) {
            return '--'
        }

        if (Array.isArray(value)) {
            return value
                .map((v) => {
                    return convertObjectToStringValue(v)
                })
                .join(', ')
        }

        return convertObjectToStringValue(value)
    }

    const classNames = () => {
        const c = ['r-input-wrapper', 'r-input-type-' + inputType, 'r-label-style-' + labelStyle, className]

        if (isValidating) {
            c.push('r-state-validating')
        }
        if (icon) {
            c.push('r-input-with-icon')
        }

        if (labelStyle === 'merged') {
            c.push('r-label-style-merged')
        }
        if (showValidationMessage) {
            c.push('r-state-invalid')
        }

        if (placeholder) {
            c.push('r-input-with-placeholder')
        }
        if (isFocused) {
            c.push('r-state-focused')
        }
        if (typeof label === 'object' && label.pos === 'left') {
            c.push('r-label-left')
        }

        if (typeof label === 'object' && label.pos === 'right') {
            c.push('r-label-right')
        }

        if (button) {
            c.push('r-input-with-button')
        }

        if (isDisabled) {
            c.push('r-state-disabled')
        }
        if (value !== null && value !== undefined && value !== '') {
            c.push('r-input-has-value')
        }

        return c.join(' ')
    }

    const validationRender = hideValidationContainer ? (
        ''
    ) : showValidationMessage ? (
        <div className={'r-input-validation-container'}>{validationMessage}</div>
    ) : (
        ''
    )

    // && (label.pos === 'right' || label.pos === 'left')
    return (
        <div className={classNames()}>
            {/*{validationRender}*/}
            <Label onClick={onLabelClick} htmlFor={'input-' + name} isRequired={isRequired} {...label} hide={noLabel}>
                {constructedLabel}
            </Label>
            <div className={'r-input-body'}>
                <div style={{ flexGrow: 1, position: 'relative' }}>
                    <div className={'r-input-icon-container'}>{icon ? <Icon type={icon} /> : null}</div>
                    {isDisplay ? (
                        <span className={'r-input-display-only'}>{renderDisplayValue()}</span>
                    ) : (
                        props.children
                    )}

                    {description && !showValidationMessage ? (
                        <div className={'r-input-description'}>{description}</div>
                    ) : null}
                    {validationRender}
                </div>
                {button ? <Button {...button} /> : ''}
            </div>

            {isValidating && !isFocused ? (
                <span className={'r-validating-indicator'}>
                    <Icon type={'spinner'} spin />
                </span>
            ) : (
                ''
            )}
        </div>
    )
}
export default InputWrapper
